import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form/immutable'
import Panel from 'react-bootstrap/lib/Panel'
import Back from 'react-icons/lib/md/arrow-back'
import { Fieldset } from 'react-gridforms'

import FieldGroupRow from 'components/FieldGroupRow'
import DefaultProfile from 'assets/img/default-profile.png'

class StudentAccount extends Component {

  componentDidMount() {
    // set username
    const { __model, dispatch } = this.props
    let username = __model.get('first_name') + '.' + __model.get('last_name')
    username = username.toLowerCase().replace(/\s+/g, '')

    if (!__model.get('username') || __model.get('username') === '.') {
      dispatch(actions.change('admissionState.username', username))
    }
    if (!__model.get('email') || __model.get('email') === '.@bisu.edu.ph') {
      dispatch(actions.change('admissionState.email', username+'@bisu.edu.ph'))
    }
  }

  _back = () => {
    this.props.setStep(1)
  }

  _renderForm() {
    const { __model } = this.props
    const Photo = __model.get('photo') ? __model.get('photo') : DefaultProfile

    return (
      <Fieldset legend="Student Account">
        <div className="row">
          <div className="col-sm-6">
            <FieldGroupRow
              model=".username"
              label="Username"
              autoFocus
              required
            />
            <FieldGroupRow
              model=".email"
              label="Email Address"
              required
            />
            <FieldGroupRow
              model=".photo"
              label="Photo URL (500x500px)"
            />
          </div>
          <div className="col-sm-6 text-center">
            <div className="picture-container">
              <div className="picture">
                <img src={Photo} alt="account_p" className="picture-src" />
              </div>
              <h6>{__model.get('full_name')}</h6>
            </div>
            <hr />
            <em className="text-muted">*** Account password will be sent to the email specified.</em>
          </div>
        </div>
      </Fieldset>
    )
  }

  render() {
    return (
      <Panel header="Student Account">
        <div className="m-b-20 row">
          <div className="col-sm-6">
            <button type="button" onClick={this._back} className="btn btn-warning"><Back /> Assign Course</button>
          </div>
          <div className="col-sm-6 text-right">
            <button type="submit" className="btn btn-success">Complete Admission</button>
          </div>
        </div>
        <hr />
        {this._renderForm()}
      </Panel>
    )
  }
}

StudentAccount.propTypes = {
  __model: PropTypes.object,
  setStep: PropTypes.func,
}

function mapStateToProps(state) {
  return {
    __model: state.admissionState,
  }
}

export default connect(mapStateToProps)(StudentAccount)



// WEBPACK FOOTER //
// ./src/containers/Admission/student-account.js